export default {
  seoTitle: 'Корзина',
  pageTitle: 'Корзина',
};
